import { isLine3 } from '../typecheck/isLine3.js';
import { isVector2Like } from '../typecheck/isVector2Like.js';
import { isVector2Tuple } from '../typecheck/isVector2Tuple.js';
import { isVector3Like } from '../typecheck/isVector3Like.js';
import { isVector3Tuple } from '../typecheck/isVector3Tuple.js';
import { isVector4Like } from '../typecheck/isVector4Like.js';
import { isVector4Tuple } from '../typecheck/isVector4Tuple.js';

/**
 * Converts an array of points to an array of positions.
 */
export const toPositions = (points: any[]): number[] =>
  points.reduce((acc, p) => {
    if (isVector3Tuple(p) || isVector4Tuple(p)) {
      return [...acc, (p as number[])[0], (p as number[])[1], (p as number[])[2]];
    } else if (isVector2Tuple(p)) {
      return [...acc, p[0], p[1], 0];
    } else if (isVector3Like(p) || isVector4Like(p)) {
      return [...acc, p.x, p.y, p.z];
    } else if (isVector2Like(p)) {
      return [...acc, p.x, p.y, 0];
    } else if (isLine3(p)) {
      return [...acc, p.start.x, p.start.y, p.start.z, p.end.x, p.end.y, p.end.z];
    } else {
      throw new Error('Invalid point type');
    }
  }, [] as number[]);
